import { getDate } from '@libs';

export const normalizeComments = (data = {}, { locale }) => {
  const { item = {} } = data || {};
  const { comments = [] } = item;

  return comments.map((item) => {
    const { id, user, body, created } = item;
    const { name, avatar } = user;
    const date = getDate(created, locale);

    return {
      id,
      date,
      body,
      name,
      avatar,
    };
  });
};
